import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  border-radius: 2em;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  min-width: 1px;\n  padding: 0.16666666666667em 0.5em;\n  text-align: center;\n'], ['\n  ', ';\n  border-radius: 2em;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  min-width: 1px;\n  padding: 0.16666666666667em 0.5em;\n  text-align: center;\n']);

import styled from 'styled-components';

var BadgeElement = styled.span(_templateObject, function (props) {
  return '\n    background-color: ' + props.backgroundColor + ';\n    color: ' + props.textColor + ';\n  ';
});
BadgeElement.displayName = 'BadgeElement';

export { BadgeElement };